<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('Заявки на демонстрационный экзамен')"></h1>
      <div class="ws-page-header-actions">
        <ws-permission-node :resources="['services/de/demoexam']" :actions="['create']" effect="display">
          <button class="ws-button button is-text" @click="editItem(true)" data-id="button-de-demoexam-create-fgos">
            <ws-icon
              class="ws-button__icon is-position-left"
              name="plus-circle"
              :title="$t('Создать заявку ФГОС')"
              color="#1c3b8d"
              width="20"
              height="20"
            />
            <strong class="ws-button__text has-text-primary">{{$t('Создать заявку на ДЭ')}}</strong>
          </button>
        </ws-permission-node>
      </div>
    </header>
    <ws-request-exams-table ref="requestExamsTable" />
  </main>
</template>

<script>
import WsRequestExamsForm from '@/components/de/request-exams/modals/WsRequestExamsForm'
export default {
  name: 'WsRequestExams',
  methods: {
    editItem (isFgos) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsForm,
        hasModalCard: true,
        canCancel: false,
        props: {
          fgos: isFgos
        },
        events: {
          'editExam': async exam => {
            await this.$refs.requestExamsTable._fetch()
          }
        }
      })
    }
  }
}
</script>
